<template>
<div id="app">
    <div id="nav">
        <router-link to="/">


            <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="">
                      <g id="">
                          <rect id="logo-bg" fill="none" x="0" y="0" width="64" height="64" rx="4"></rect>
                          <path d="M22,26 C19.790861,26 18,24.209139 18,22 C18,19.790861 19.790861,18 22,18 C24.209139,18 26,19.790861 26,22 C26,24.209139 24.209139,26 22,26 Z M41,26 C38.790861,26 37,24.209139 37,22 C37,19.790861 38.790861,18 41,18 C43.209139,18 45,19.790861 45,22 C45,24.209139 43.209139,26 41,26 Z M53.3888542,38.4499666 C48.8510224,46.6741876 40.7776968,52.230403 32.0960954,52.230403 C22.8635068,52.230403 14.5637694,46.8042034 10.3187622,38.3463741 C9.57554125,36.8655673 10.1734727,35.0626367 11.6542795,34.3194158 C13.1350863,33.5761949 14.9380169,34.1741264 15.6812378,35.6549331 C18.9343447,42.1364821 25.1962721,46.230403 32.0960954,46.230403 C38.4153377,46.230403 44.5865901,41.9832305 48.1354774,35.5513407 C48.9359108,34.1006607 50.7607988,33.5735318 52.2114787,34.3739652 C53.6621587,35.1743986 54.1892876,36.9992866 53.3888542,38.4499666 Z" id="logo" fill="#FFFFFF"></path>
                      </g>
                  </g>
              </g>
          </svg> </router-link>


    </div>
    <transition name="fade">
        <router-view/>
    </transition>

    <!-- <Participate/> -->
</div>
</template>

<style>
html{


}
body {
    /* background: url("./assets/bg.png"); */
    background-color: #FF4166;
    background-size: 100% auto;

}

#app {
    font-family: 'Overpass Mono', monospace;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;

    color: black;
}

button {
    padding: 0;
    border: none;
    font: inherit;
    color: inherit;
    /* show a hand cursor on hover; some argue that we
should keep the default arrow cursor for buttons */
    cursor: pointer;
    min-width: 60px;
    background-color: #F1f1f1;
    font-size: 20px;
    margin: 12px;
    padding: 12px;
    border-radius: 4px;
    color: black;
}

#logo:hover {
    fill: black;
}

#logo-bg:hover {
    fill: black;
}

a {
    color: white;
    font-weight: 800;
}

h1,
h2 {
    font-size: 4vh;
}

footer {
    /* position: fixed; */
    bottom: 1em;
    right: 1em;
    margin-top: 3em;
    margin-bottom: 1em;
}


button:hover {
    background: grey;
}

#nav {
    position: fixed;
    top: 2em;
    left: 2em;
    z-index: 100;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a:hover {
    /* background: black; */
}


#nav a.router-link-exact-active {
    color: #42b983;
}

.fade-enter-active,
fade-leave-active {
    transition: opacity 1s;
}

.fade-enter,
fade-leave-to {
    opacity: 0;
}

@media (max-width: 764px) {
    #nav {
        position: absolute;
    }
}
</style>

<script>
import firebase from 'firebase'
import Participate from '@/components/participate.vue'

export default {
    name: 'app',
    data() {
        return {
            userId: ''
        }
    },
    components: {
        Participate
    },
    mounted: function() {
        this.currentUser()
    },
    methods: {
        currentUser: function() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.userId = user.email;
                    this.$store.commit('setUser', user.uid)
                }
            })
        },
    }
}
</script>
